import { toJS } from 'mobx';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useState, useContext } from 'react';
import { isEmpty } from 'underscore';
import { Context } from '../..';
import AskService from '../../services/AskService';
import UserService from '../../services/UserService';
import { QAModal } from './modal/QAModal';

const QA: FC<any> = observer(({ item, setQAModal, setQAID }) => {

    return (
        <div className="col-md-2 m-3 mb-5" style={{ cursor: "pointer" }} onClick={() => {
            setQAModal(true);
            setQAID(item['id']);
        }}>
            <hr />
            <div className="mb-2">
                {!isEmpty(item['answers']) ? <i className='icon check' /> : <i className='icon wait' />}
                <em>
                    {new Date(item['question_date']).toLocaleDateString("ru-RU", {
                        hour: 'numeric',
                        minute: 'numeric',
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric'
                    })}
                </em>
            </div>
            <div className="mb-2">
                <h6>{item['subject'].substring(0, 100) + (item['subject'].length < 100 ? '' : '...')}</h6>
            </div>
            <div className="mb-2">
                <em>{item['fio']}</em>
            </div>
        </div>
    )
});

const QuestionsToMe: FC = () => {
    const { store } = useContext(Context)
    const [qaModal, setQAModal] = useState<boolean>(false);
    const [qaID, setQAID] = useState<any>({});
    const [specializations, setSpecializations] = useState<[]>([]);
    const [specTitle, setSpecTitle] = useState<string[]>([]);
    const [organizations, setOrganizations] = useState<[]>([]);
    const [orgTitle, setOrgTitle] = useState<string[]>([]);
    const [fix, setFix] = useState(true);
    const quan = toJS(store.qa)


    useEffect(() => {
        if (!isEmpty(specializations)) {
            setSpecTitle([]);
            // eslint-disable-next-line array-callback-return
            specializations.forEach(item => {
                // eslint-disable-next-line array-callback-return
                store.specInfo.specializations?.forEach((sid: any) => {
                    if (item['id'] === sid) {
                        setSpecTitle(specTitle => [...specTitle, item['specialization']]);
                    }
                });
            });
        };
        if (!isEmpty(organizations)) {
            setOrgTitle([]);
            // eslint-disable-next-line array-callback-return
            organizations.forEach(item => {
                // eslint-disable-next-line array-callback-return
                store.specInfo.organizations?.forEach((sid: any) => {
                    if (item['id'] === sid) {
                        setOrgTitle(orgTitle => [...orgTitle, item['organization']]);
                    }
                });
            });
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [specializations, organizations]);

    const getSpecializations = async () => {
        const res = await UserService.getSpecializations('');
        setSpecializations(res.data.results);
    };

    const getOrganizations = async () => {
        const res = await UserService.getOrganizations('');
        setOrganizations(res.data.results);
    };

    const getQA = async () => {
        const qa = await AskService.getSpecQ();
        store.setQA(qa.data.results);
    };

    useEffect(() => {
        getQA();
        getSpecializations();
        getOrganizations();
        return () => setFix(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fix])

    const getItems = () => quan?.sort((a: any, b: any) => b['id'] - a['id']).map((item: any, i: number) => {
        return <QA key={i} {...{ item, setQAModal, setQAID }} />
    })


    return (
        <div className='row'>
            {getItems()}
            <QAModal toggle={qaModal} setToggle={setQAModal} qaID={qaID} spec={specTitle} org={orgTitle} />
        </div>
    )
};
export default observer(QuestionsToMe);